import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import './application.css'

// Lazy glob (no `eager`): Vite code-splits one chunk per page, so first paint
// downloads only the visited page instead of the whole admin app — the eager
// form had grown the single bundle past 1.2MB, all of it parsed on the login
// screen. Inertia awaits the returned promise.
// Test files are excluded so page-adjacent *.test.tsx are real Vitest specs,
// never routable page chunks (the exclusion is pinned by
// app/frontend/test/pageGlob.test.ts).
const pages = import.meta.glob(['../pages/**/*.tsx', '!../pages/**/*.test.tsx'])

createInertiaApp({
  // "<record> · Elis" in the browser tab, so a row of Elis tabs can be told
  // apart (17 Sept: "add project name"). Pages set the record via <Head title>.
  title: (title) => (title ? `${title} · Elis` : 'Elis'),
  resolve: async (name) => {
    const loader = pages[`../pages/${name}.tsx`]
    if (!loader) {
      throw new Error(`Page not found: ${name}`)
    }
    return await loader()
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
